import numberFormat from '@/filter/numberFormat';
import moment from 'moment';

moment.locale('ja');

export function 必須入力(value: string): boolean {
  if (!value) {
    return false;
  }
  return true;
}

export function ゼロを許可する必須入力(value: number): boolean {
  if (!value && value !== 0) {
    return false;
  }
  return true;
}

export function 半角カナ禁止(value: string): boolean {
  if (!value) {
    return true;
  }
  if ( value.match(/[ｱ-ﾝﾞﾟ]+/) ) {
    return false;
  }
  return true;
}

export function 半角のみ(value: string) {
  if (value === null) {
    return true;
  }

  if (value.match(/^[!-~\¥]*$/)) {
    return true;
  }

  return false;
}

export function 半角英数のみ(value: string) {
  if (value === null) {
    return true;
  }

  if (value.match(/^[A-Za-z0-9]*$/)) {
    return true;
  }

  return false;
}

export function 半角数のみ(value: string) {
  if (value === null) {
    return true;
  }

  if (value.match(/^[0-9]*$/)) {
    return true;
  }

  return false;
}

export function 全角のみ(value: string) {
  if (value === null) {
    return true;
  }

  if (value.match(/^[^ -~｡-ﾟ]*$/)) {
    return true;
  }

  return false;
}

export function 日付書式(value: string | Date): boolean {
  if (!value) {
    return true;
  }
  if (typeof value === 'string') {
    // YYYY-MM-DD
    if (value.match(/^[12][0]\d{2}-\d{2}-\d{2}/g)) {
      const year = value.slice(0, 4);
      const month = value.slice(5, 7);
      const day = value.slice(8, 10);
      const date = moment(year + '-' + month + '-' + day);

      return date.isValid();
    }
    return false;
  }
  return true;
}

export function 年月書式(value: string | Date): boolean {
  if (!value) {
    return true;
  }
  if (typeof value === 'string') {
    // YYYY-MM
    if (value.match(/^[12][0]\d{2}-\d{2}/g)) {
      const year = value.slice(0, 4);
      const month = value.slice(5, 7);
      const date = moment(year + '-' + month + '-01');

      return date.isValid();
    }
    return false;
  }
  return true;
}

export function 年書式(value: string | Date): boolean {
  if (!value) {
    return true;
  }
  if (typeof value === 'string') {
    // YYYY-MM
    if (value.match(/^[12][0]\d{2}/g)) {
      const date = moment(value + '-01-01');
      return date.isValid();
    }
    return false;
  }
  return true;
}

export function 時刻書式(value: string): boolean {
  if (!value) {
    return true;
  }
  return value.match(/^[0-2][0-9]:[0-5][0-9]$/g) !== null;
}

export function 小数制限(value: number, integer: number, decimal: number): boolean {
  if (!value) return true;
  if (!isFinite(value)) return false;
  const numberString = value.toString();
  if (numberString.indexOf('.') < 0) return numberString.length <= integer;
  const splitNumber = numberString.split('.');
  if (splitNumber.length > 2) return false;
  const integerValue = splitNumber[0];
  const decimalValue = splitNumber[1];
  return integerValue.length <= integer && decimalValue.length <= decimal;
}

export function 文字列長制限(value: string, length: number): boolean {
  if (!value) return true;
  return value.length <= length;
}

export function ゼロ以上(value: number): boolean {
  return value >= 0;
}

export function 数値範囲指定(value: number, lowerLimit: number, upperLimit: number): boolean {
  return lowerLimit <= value && value <= upperLimit;
}

export function 一覧必須制限(value: []) {
  return value.length !== 0;
}

export const 整数制限 = (value: number) =>  {
  return Number.isInteger(value);
};

